// global
export const UPDATE_HEADER = 'UPDATE_HEADER'
export const LOADING = 'LOADING'
export const GET_USERS_BY_ID_SUCCESS = 'GET_USERS_BY_ID_SUCCESS'
export const GET_USERS_BY_ID_FAILED = 'GET_USERS_BY_ID_FAILED'
export const SUCCESS = 'SUCCESS'

// warehouse
export const CREATE_RECORD_REQUEST = 'CREATE_RECORD_REQUEST'
export const CREATE_RECORD_SUCCESS = 'CREATE_RECORD_SUCCESS'
export const CREATE_RECORD_ERROR = 'CREATE_RECORD_ERROR'
export const RECORD_FORM_ON_CHANGE = 'RECORD_FORM_ON_CHANGE'
export const RESET_RECORD_FORM = 'RESET_RECORD_FORM'
export const RESET_UPLOAD_IMAGE = 'RESET_UPLOAD_IMAGE'

// merchant
export const SEARCH_QUERY_ON_CHANGE = 'SEARCH_QUERY_ON_CHANGE'
export const GET_RECENT_POLICY_MERCHANT_SUCCESS = 'GET_RECENT_POLICY_MERCHANT_SUCCESS'
export const GET_RECENT_POLICY_MERCHANT_FAILED = 'GET_RECENT_POLICY_MERCHANT_FAILED'
export const SEARCH_POLICY_BY_TAOBAO_ID_SUCCESS = 'SEARCH_POLICY_BY_TAOBAO_ID_SUCCESS'
export const SEARCH_POLICY_BY_TAOBAO_ID_FAILED = 'SEARCH_POLICY_BY_TAOBAO_ID_FAILED'

// customer service
export const CS_SEARCH_QUERY_ON_CHANGE = 'CS_SEARCH_QUERY_ON_CHANGE'
export const GET_RECENT_POLICIES_BY_CLAIM_STATUS_SUCCESS = 'GET_RECENT_POLICIES_BY_CLAIM_STATUS_SUCCESS'
export const GET_RECENT_POLICIES_BY_CLAIM_STATUS_FAILED = 'GET_RECENT_POLICIES_BY_CLAIM_STATUS_FAILED'
export const GET_UNLINKED_WAREHOUSE_RECORDS_SUCCESS = 'GET_UNLINKED_WAREHOUSE_RECORDS_SUCCESS'
export const GET_UNLINKED_WAREHOUSE_RECORDS_FAILED = 'GET_UNLINKED_WAREHOUSE_RECORDS_FAILED'
export const GET_WAREHOUSE_RECORD_BY_ID_SUCCESS = "GET_WAREHOUSE_RECORD_BY_ID_SUCCESS"
export const GET_WAREHOUSE_RECORD_BY_ID_FAILED = "GET_WAREHOUSE_RECORD_BY_ID_FAILED"
export const START_DATE_ON_CHANGE = "START_DATE_ON_CHANGE"
export const END_DATE_ON_CHANGE = "END_DATE_ON_CHANGE"
export const SEARCH_ZHONGAN_POLICY_SUCCESS = "SEARCH_ZHONGAN_POLICY_SUCCESS"
export const SEARCH_ZHONGAN_POLICY_FAILED = "SEARCH_ZHONGAN_POLICY_FAILED"
export const SEARCH_SLAB_POLICY_SUCCESS = "SEARCH_SLAB_POLICY_SUCCESS"
export const SEARCH_SLAB_POLICY_FAILED = "SEARCH_SLAB_POLICY_FAILED"
export const GET_GENERAL_POLICY_SUCCESS = "GET_GENERAL_POLICY_SUCCESS"
export const GET_GENERAL_POLICY_FAILED = "GET_GENERAL_POLICY_FAILED"
export const UPDATE_CLAIM_STATUS_SUCCESS = "UPDATE_CLAIM_STATUS_SUCCESS"
export const UPDATE_CLAIM_STATUS_FAILED = "UPDATE_CLAIM_STATUS_FAILED"

// login
export const ACCOUNT_ON_CHANGE = 'ACCOUNT_ON_CHANGE'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGIN_FAILED = 'LOGIN_FAILED'

// return request details
export const RETURN_REQUEST_ON_CHANGE = 'RETURN_REQUEST_ON_CHANGE'
export const UPDATE_RETURN_ITEM = 'UPDATE_RETURN_ITEM'
export const CREATE_OR_UPDATE_POLICY_SUCCESS = 'CREATE_OR_UPDATE_POLICY_SUCCESS'
export const CREATE_OR_UPDATE_POLICY_FAILED = 'CREATE_OR_UPDATE_POLICY_FAILED'
export const GET_POLICY_BY_ID_SUCCESS = 'GET_POLICY_BY_ID_SUCCESS'
export const GET_POLICY_BY_ID_FAILED = 'GET_POLICY_BY_ID_FAILED'
export const COMMENT_ON_CHANGE = 'COMMENT_ON_CHANGE'
export const ADD_COMMENT_SUCCESS = 'ADD_COMMENT_SUCCESS'
export const ADD_COMMENT_FAILED = 'ADD_COMMENT_FAILED'
export const CREATE_INVENTORY_ITEM_SUCCESS = 'CREATE_INVENTORY_ITEM_SUCCESS'
export const CREATE_INVENTORY_ITEM_FAILED = 'CREATE_INVENTORY_ITEM_FAILED'

// item modal
export const RETURN_ITEM_ON_CHANGE = 'RETURN_ITEM_ON_CHANGE'
export const CREATE_UPDATE_RETURN_ITEM = 'CREATE_UPDATE_RETURN_ITEM'
export const TOGGLE_STAGING_RECORD_MODAL = 'TOGGLE_STAGING_RECORD_MODAL'

// image upload Button
export const UPLOAD_IMAGE_SUCCESS = 'UPLOAD_IMAGE_SUCCESS'
export const DELETE_UPLOAD_IMAGE = 'DELETE_UPLOAD_IMAGE'

// warehouse record
export const LINK_ID_ON_CHANGE = 'LINK_ID_ON_CHANGE'
export const LINK_RECORD_TO_ORDER_SUCCESS = 'LINK_RECORD_TO_ORDER_SUCCESS'
export const LINK_RECORD_TO_ORDER_FAILED = 'LINK_RECORD_TO_ORDER_FAILED'
export const DELETE_WAREHOUSE_RECORD_SUCCESS = 'DELETE_WAREHOUSE_RECORD_SUCCESS'
export const DELETE_WAREHOUSE_RECORD_ERROR = 'DELETE_WAREHOUSE_RECORD_ERROR'

// general return details
export const GET_WAREHOUSE_RECORDS_SUCCESS = 'GET_WAREHOUSE_RECORDS_SUCCESS'
export const GET_WAREHOUSE_RECORDS_FAILED = 'GET_WAREHOUSE_RECORDS_FAILED'
export const TOGGLE_INVENTORY_ITEM_MODAL = 'TOGGLE_INVENTORY_ITEM_MODAL'
export const UPDATE_INVENTORY_ITEM = 'UPDATE_INVENTORY_ITEM'
export const DELETE_INVENTORY_ITEM_SUCCESS = 'DELETE_INVENTORY_ITEM_SUCCESS'
export const DELETE_INVENTORY_ITEM_FAILED = 'DELETE_INVENTORY_ITEM_FAILED'

// change Password
export const PASSWORD_FORM_ON_CHANGE = 'PASSWORD_FORM_ON_CHANGE'
export const CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS'
export const CHANGE_PASSWORD_FAILED = 'CHANGE_PASSWORD_FAILED'

// Resell Beta
export const SEARCH_RECEIVED_PRODUCTS_SUCCESS = 'SEARCH_RECEIVED_PRODUCTS_SUCCESS'
export const SEARCH_RECEIVED_PRODUCTS_FAILED = 'SEARCH_RECEIVED_PRODUCTS_FAILED'
export const GET_RECEIVED_PRODUCT_SUCCESS = 'GET_RECEIVED_PRODUCT_SUCCESS'
export const GET_RECEIVED_PRODUCT_FAILED = 'GET_RECEIVED_PRODUCT_FAILED'

// Stock In
export const GET_POLICY_BY_TRACKING_NUMBER_SUCCESS = 'GET_POLICY_BY_TRACKING_NUMBER_SUCCESS'
export const GET_POLICY_BY_TRACKING_NUMBER_FAILED = 'GET_POLICY_BY_TRACKING_NUMBER_FAILED'
export const STOCK_IN_WAREHOUSE_RECORDS_SUCCESS = 'STOCK_IN_WAREHOUSE_RECORDS_SUCCESS'
export const STOCK_IN_WAREHOUSE_RECORDS_FAILED = 'STOCK_IN_WAREHOUSE_RECORDS_FAILED'

// staging record modal
export const UPDATE_STAGING_RECORD = 'UPDATE_STAGING_RECORD'
export const CREATE_STAGING_RECORD_SUCCESS = 'CREATE_STAGING_RECORD_SUCCESS'
export const CREATE_STAGING_RECORD_FAILED = 'CREATE_STAGING_RECORD_FAILED'
export const GET_STAGING_RECORD_SUCCESS = 'GET_STAGING_RECORD_SUCCESS'
export const GET_STAGING_RECORD_FAILED = 'GET_STAGING_RECORD_FAILED'



// WEBPACK FOOTER //
// ./src/constants.js